            
function Widget({ career, image }) {
  return (
    <div class="col-12 col-lg-4 order-first order-lg-last">
      <div class="ed_view_box style_3">
        <div class="sm">
          <div class="thumb">
            <img class="img-fluid ht-300 w-100 object-fit" src={image} alt={career.name} />
          </div>
        </div>
        <div class="author-body px-4 pb-5">
          <div class="ed_view_price my-5">
            <span>Titulo a obtener</span>
            <h4 class="lh-base">{career.title}</h4>
          </div>
          <div class="mb-5 px-4 text-center">
            <ul>
              <li className="li-icons my-3">
                <span><i class="bi bi-person-workspace"></i></span>
                Modalidad: {career.virtual ? "Presencial y Multimodal (presencial y a distancia)" : "Presencial"}
              </li>
              <li className="li-icons my-3">
                <span><i class="bi bi-hourglass-split"></i></span>
                Duración total: 28 meses
              </li>
              <li className="li-icons my-3">
                <span><i class="bi bi-calendar-date"></i></span>
                Duración de cada periodo: 4 meses
              </li>
              {career.continuationOfStudies && (
                <li className="li-icons my-3">
                  <span><i class="bi bi-patch-check-fill"></i></span>
                  Continuación de estudios mediante el convenio con la Universidad del Zulia (LUZ)
                </li>
              )}
            </ul>
          </div>
          <div class="ed_view_link d-flex align-items-center justify-content-center flex-column gap-3 m-0 p-0">
            <a href="/admision" class="btn btn-main w-100 ">Admision</a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Widget;